export default {
   "en": {
      nav: {
         dashboard: "Dashboard",
         login: "Login",
         logout: "Logout",
         admin: "Administration",
         ddo_extranet: "DDO EXTRANET",
         mallatius_extranet: "MALLATIUS EXTRANET",
         plf_admin: "Administration",
         plf_exchange: "Exchange Platform",
         reseller: "Resellers",
         myprofile: "My profile",
         catalog: "Catalog",
         catalogtest:"Catalog Test" , 
         mycompany: "My Company",
         infra: "Infrastructure",
         identities: "Identities",
         settings: "Settings",
         crg: "Certificate Registars",
         cer: "Certificates",
         cus: "Customers",
         net: "Networks",
         vla: "VLANs",
         ipa: "IP Addresses",
         dtc: "Datacenters",
         equ: "Equipments",
         dtr: "Datacenter Rows",
         rck: "Racks",
         shc: "Shortcodes",
         plf: "Platforms",
         prc: "Products",
         inv: "Invoices",
         sla: "SLA",
         product: "Categories and Products",
         monitoring: "Monitoring",
         monitoring_log: "Logs",
         monitoring_racks_in_dc: "Racks in DC",
         monitoring_certificatedeployments: "Deployed Certs.",
         monitoring_customercontacts: "Customer Contacts",
         monitoring_customerservicesmtppro: "SMTP-PRO Service",
         monitoring_customerservicesmspro: "SMS-PRO Service",
         monitoring_customerservicebackupbareos: "BAREOS Backup Service",
         monitoring_logs: "Logs",

         zoho2prestige: "ZOHO to PRESTIGE conversion",
         zohoconv: "Zoho2Prestige",
         monitoring_customers: "CUSTOMER Service",
         monitoring_customerresellers: "CUSTOMER RESELLERS Service",

         dtc_one : "Datacenter",
         dtr_one : "Row",
      },

      links: {
         manage_smtppro: "Manage SMTP-PRO",
         manage_smspro: "Manage SMS-PRO",
      },

      buttons: {
         create_item: "Create Item",
         create_network: "Create Network",
         generate_ipa: "IPv4",
         close: "Close",
         display: "Display",
         create: "Create",
         edit: "Edit",
         update: "Save",
         modify: "Modify",
         delete: "Delete",
         cancel: "Cancel",
         confirm: "Confirm",
         login: "Login",
         send: "Send",
         ok: "OK",
         convert: "Convert",
         to_clipboard: "To clipboard",
         create_ldapconnector: "Attach a new Identity Managment Platform",
         generate_password: "Generate Password",
         attach_platform: "Attach a Platform",
         attach_this_platform: "Attach this Platform",
         attach_this_service: "Attach this Service",
         resetpassword: "Apply",
         search: "Search",
         create_contact: "Create new Contact",
         export_csv: "Export to CSV file",
         sync_from_zoho: "Sync from ZOHO",
         back_catalog: "Back",
         category_catalog: "Categories",
         plans_catalog: "Plans",
         order_catalog: "Order",
         pay_by_card: "Pay by Card",
         dns_record_to_create: "Check DNS and Validate",
         check_dns_and_validate: "Check DNS and Validate",
         export_month_csv_with_status: "Export CSV for Status '%s', Current Month : %s", 
         export_month_csv: "Export CSV, Current Month : %s", 
      },

      titles: {
         crg: "List of Certificate Registars",
         dtc: "List of Datacenters",
         dtr: "List of Rows",
         rck: "List of Racks",
         net: "List of Networks",
         vla: "List of VLANs",
         ldc: "List of Identity Managment Platforms",
         shc: "List of Shortcodes",
         cus: "List of Customers",
         equ: "List of Equipments",
         ced: "List of Certificates and their Deployments",
         prc: "Categories and Products",
         pro: "Products",
         inv: "Invoices",
         dkr: "DKIM Records",
         sla: "SLA (Service Level Agreement)",
         sla_short: "SLA",
         search_mails_out: "Search Outgoing Mails",
         search_sms_out: "Search Outgoing SMS",
         search_jobs: "Search Jobs",
         search: "Search",
         graphs: "Graphs",
         zoom_graph: "Zoom on Graph",
         for_account: "for account",
         smtppro_details: "Details",
         smspro_details: "Details",
         backupbareos_details: "Details",
         tile_certs: "SSL Certificates",
         tile_smtppro: "SMTP-PRO",
         tile_smspro: "SMS-PRO",
         tile_backupbareos: "BAREOS",
         synthesis: "Synthesis",
         prices: "Prices",
         _DEVELOPMENT: "DEVELOPMENT",
         invoices: "Invoices",
         orders: "Orders",
         payment_by_card: "Payment by Card",
         settings: "Settings",
         settings_spf_dkim: "SPF and DKIM Settings",
         _spf_full_settings: "SPF Settings",
         _dkim_full_settings: "DKIM Settings",
         _dns_record_to_create: "DNS Record to create",
      },

      subtitles: {
         cer: "List of SSL Certificates of Registar %s",
         ced: "List of Deployments for Certificate %s",
         dtr: "List of Rows of Datacenter %s",
         rck: "List of Racks of Row %s",
         equ: "List of Equipments in Rack %s",
         ipa: "Table of IP Addresses of Network Block %s",
         lde: "List of Identities from '%s'",

         monitoring_unknown_codes_this_month: "Unknwon codes with activity, this month",
         monitoring_known_codes: "Known Codes",

         properties: "Properties",
         contacts: "Contacts",
         postal_address: "Postal Address",
         phones: "Phones",
         phone_fixed: "Landline Number",
         phone_cell: "Cellular Number",
         properties_bm: "Accounting+BM Properties",
         properties_glpi: "GLPI Properties",
         properties_smtppro: "SMTP-PRO Properties",

         counting_method: "Counting Method",

         xxx_platforms: "List of Platforms for Customer %s",

         ldc_section_platform: "Platform",
         ldc_section_ou: "Customer OU",
         ldc_section_dynamic: "Authentication Server",
         ldc_section_auth: "Authentication Informations",
         ldc_section_exchange: "Exchange Informations",

         lde_properties: "Properties",
         lde_member_of: "Member of",
         lde_useraccountcontrols: "Account Options",
         lde_accountname: "Account IDs",
         lde_userprincipalname: "Account to open session (UserPrincipalName)",
         lde_samaccountname: "Account before Windows 2000 (SamAccountName)",

         shc_macros: "Available Macros",
         shc_steps: "Steps",

         equ_properties: "Properties",
         equ_positions: "Position in Rack",
         equ_rack: "Linked to the Rack",

         crg_margins: "Thresholds",
         cer_properties: "Properties",
         cer_attachments: "Attachments",

         settings: "Settings",
         addaccount: "Add an account",
         listaccount: "Existing Account",
         listaccounts: "Already registered Accounts",
         listpatterns: "REGEX pattern for CA Names",
         addbareosclientname: "Name of the 'Client' Entity",

         inform_by_mail_of_excess: "Send surchage informations by email",
         inform_by_mail_of_backups: "Send backups informations by email",
         inform_by_mail_of_certificates: "Send certificates informations by email",
         inform_to_customer: "To Customer",
         inform_to_manager: "To Manager",

         filters: "Filters",
         
         ced_certificate_part: "For the Certificate",
         ced_deployment_part: "For the first Deployment of this Certificate",

         search_criteria: "Search Criteria", 
         search_results: "Search Results", 
         search_account: "For the account",
         search_status: "Mails with the Status", 
         search_status_sms: "SMS with the Status",
         search_status_jobs: "Jobs with the Status", 
         search_daterange: "Dates Range",
         search_selecteddaterange: "Selected Date(s)",  
         search_sender: "Sender", 
         search_recipient: "Recipient",
         search_sentfromip: "Sent from IP",
         search_sendingname: "Sending name", 
         synthesis_count_per_status_on_last_days: "Counting Outgoing Mails per Delivery Status, on Last 14 Days",
         synthesis_count_sms_per_status_on_last_days: "Counting Outgoing SMS per Delivery Status, on Last 7 Days",
         synthesis_count_jobs_per_status_on_last_days: "Counting Outgoing Jobs per Status, on Last 7 Days", 

         contact_general: "Main Contat",

         settings_zoho: "ZOHO Settings",
         settings_local: "Local Settings",
         
         plans: "Plans",
         html_presentation: "HTML Presentation",

         invoices: "Invoices",
         orders: "Orders",
         identity: "Identity",
         ctc_general: "General Contact",
         ctc_billing: "Billing Contact",
         ctc_shipping: "Shipping Contact",

         sla_computed: "Computed SLA entries",
         sla_flags: "SLA Flags",
         sla_datetime_interval: "SLA Date+Time Range",
         cus_plf_bindings: "Linked to Customer or Platform",

         equ_networks: "NIC Informations",
      },

      headers: {
         actions: "Actions",
         action_refresh: "Refresh",
         code: "Code",
         name: "Name",
         description: "Description",
         created_on: "Created on",
         updated_on: "Updated on",
         alternative_or: "OR",

         _details: "Details",
         _data: "Data",
         _customer: "Customer",
         _account: "Account",
         _thresholds: "Thresholds",
         _counters: "Counters",
         _status: "Status",
         _visible: "Visible",
         _default: "Default",
         _pdf_link: "PDF Link",
         _refreshed_on: "Refreshed on",
         _exported: "Exported",

         cer: "Certif.",
         ipa: "IP Addr.",
         dtr: "Rows",
         rck: "Racks",
         lde: "Identities",

         cer_cn: "Certificate Name (CN)",
         ced_check_uri_and_code: "Deployment (URI+Code)",

         xxx_connector_name: "ID Managment Platform",

         flags: "Flags",
         ipa_affectation: "IP Affectations",
         cidr: "CIDR",

         plf_name: "Platform",
         platforms: "Platforms",
         vla_id: "VLAN",
         xxx_steps: "Steps",

         messages: "Messages",
         sms: "SMS",
         megabytes: "Megabytes",
         files: "Files",
         volume: "Volume",

         equ_position_from: "Location",
         equ_count: "Equipments",
         equ_location: "Rack",

         prc_name: 'Categorie Name',
         prc_level: 'Level',
         prt_bm_entity_name: 'ZOHO Entity Name',
         pro_name: "Product Name",

         datetime: "Date+Time",
         datetime_gmt: "Date+Time (GMT)",
         messageid: "Message ID",
         jobid: "Job ID",
         jobname: "Job Name",
         sendername: "Sending name",
         servername: "Server",
         recipient: "Recipient",
         status: "Status",
         smsconsumed: "SMS Consumed",
         addressrequestip: "Sent from IP",
         errormessage: "Message: Error Message",
         count_submitted: "Submitted",

         comments: "Comments",
         traces: "Traces",

         log_event: "Event Date",
         log_ipv4: "From IPV4",
         log_function: "Function",
         log_action: "Action",
         log_traces_json_lite: "More info",

         synthesis_date: "Date", 
         synthesis_account: "Account", 
         synthesis_sent: "Sent", 
         synthesis_bounced: "Bounced", 
         synthesis_expired: "Expired", 
         synthesis_deferred: "Deferred", 
         synthesis_graph: "Graph", 

         deliverability_average_time: "Avg Time Deliverability",
         deliverance_average_time: "Avg Time Deliverance",

         synthesis_day: "Result Day",
         synthesis_backup_account: "Backup Account",
         synthesis_backup_ok: "Done", 
         synthesis_backup_cancelled: "Cancelled", 
         synthesis_backup_failed: "Failed", 

         cus_name: "Customer Name",
         inv_code: "Invoice Number",
         inv_date: "Invoice Date",
         inv_is_invoice: "Nature",
         inv_bm_specific_fields: "Period",
         ins_name: "Status",
         inv_signed_total_price: "Amount",

         dkr_domainname: "Domain Name",
         dkr_publickey: "DKIM Public Key",

         sla_name: "SLA Text",
         sla_active: "SLA Flags",
         sla_event_start: "Start/Stop Range",

      },

      utils: {
         MB: "MB",
         Mbytes: "Mbytes",
         mb: "mb",
         GB: "GB",
         Gbytes: "Gbytes",
         gb: "gb",
         MBytes: "MBytes",
         megabytes: "megabytes",
         _netprice: "Net price",
         _grossprice: "Gross price",
         _BP: "w/o VAT",
         _GP: "w VAT",
         _bp: "w/o vat",
         _gp: "w/ vat",
         _BP_pm: "w/o VAT, per month",
         _bp_pm: "w/o vat, per month",
         _BP_py: "w/o VAT, per year",
         _bp_py: "w/o vat, per year",
         _datefrom: "From ",
         _dateto: "To ",
      },

      texts: {
         loading: "Loading",
         requiredfield: "indicates required field",
         signin_title: "Login",
         signin_subtitle: "Sign In to your account !",
         signin_login: "User ID",
         signin_email: "User Email",
         signin_password: "Password",
         signin_forgot_password: "Forgot password?",
         signup_title: "Sign up",
         signup_new_website: "Welcome on my ",
         //signup_explanations: "This website is dedicated to our Customers, to help them to manage their products. You can register here, and a DDO Customer Representative will contact you as soon as possible",
         signup_explanations_1_ddo: "Already a DDO Customer ? Sign-in to see your Services at DDO.",
         signup_explanations_2_ddo: "You are not already a DDO Customer and you are interested by our Products and Services.<br/>Contact-us :<br/>",
         signup_explanations_1_smtppro: "Already a DDO Customer ? Sign-in to see your Services at SMTP-PRO.",
         signup_explanations_2_smtppro: "You are not already a SMTP-PRO Customer and you are interested by our Products and Services.<br/>Click hereunder :<br/>",

         signup_register_now: "Register Now",
         switch_customer: "Switch Customer",
         session_itself: "My own data",
         change_password1: "New Password",
         change_password2: "Repeat New Password",
         forgotpassword_title: "Forgot Password ?",
         forgotpassword_subtitle: "Give us your ID, and we will send you a link to the associated email, to reset your password",
         forgotpassword_return: "Return to Login",
         resetpassword_title: "Reset Password",
         resetpassword_subtitle: "You may redefine your Password here :",
         list_mode: "List Mode",
         list_certificates: "Certificates",
         list_registars: "Registars",
         certificates_certificates_month: "Certificates monitored",
         accounts: "no account | 1 account | {count} accounts",
         certificates_list: "Certificates",

         method_recurrent: "Recurrent (Monthly) Method",
         method_quota: "Quota Method",
         method: "Method",
         
         countrySelectorLabel: "Country Code",
         countrySelectorError: "Choose a Country",
         phoneNumberLabel: "Phone Number",
         example: "Example",

         level_ok: "OK Level",
         level_warning: "Warning Level",
         level_error: "Error Level",
         level_ok_short: "OK",
         level_warning_short: "Warning",
         level_error_short: "Error",

         invoice: "Invoice",
         creditnote: "Credit Note",

         equipmenttype: "Equipment Type",
         equipment: "Equipment",

         _required: "Field is required",
         _code: "Code",
         _required_code: "Code*",
         _name: "Name",
         _required_name: "Name*",
         _desc: "Description",
         _email_format: "Must follow the format : <whatever>@<domain>.<extension>. For instance : contact@domain.com",
         _bm_name_format: "Must only contains alphabetical characters, no digit, no special characters",
         _domainname_format: "Must follow the format : <domain>.<extension>. For instance : domain.com",
         _email: "Email",
         _job: 'Job',
         _emails: "Emails",
         _sms: "SMS",
         _jobs: 'Jobs',
         _files: 'Files',
         _active: "Active",
         _inactive: "Inactive",
         _activated: "Activated",
         _deactivated: "Deactivated",
         _status: "Status",
         _expired: "Expired",
         _expired_since: "Expired since",
         _expires_on: "Expires on",
         _suspended: "Suspended",
         _suspended_since: "Suspended since",
         _minimal_root_path: "You have given a Path lesserthan the minimal allowed",
         _firstname: "Firstname",
         _lastname: "Lastname",
         _level: "Niveau",
         _order: "Rang",
         _orderpath: "Chemin de tri",

         _cookies_law_1: "This website uses session cookies for a better User experience",
         _cookies_law_2: "The only external cookie is for Google Analytics",
         _cookies_law_3: "Do you want to continue ?",
         _cookies_law_accept: "I accept",
         _cookies_law_deny: "I deny",

         net_ipv4: "is IP v4",
         net_ipv6: "is IP v6",
         net_public: "is public",
         net_deployable: "deployable",
         net_create_title: "Create Network",
         net_update_title: "Update Network",
         net_delete_title: "Delete Network",

         dtc_create_title: "Create Datacenter",
         dtc_update_title: "Update Datacenter",
         dtc_delete_title: "Delete Datacenter",
         dtc_address: "Postal Address",

         dtr_position: "Position",
         rck_size_u: "Size (U)",
         dtr_create_title: "Create Row of Racks",
         dtr_update_title: "Update Row of Racks",
         dtr_delete_title: "Delete Row of Racks",
         dtr_location: "Location",

         rck_position: "Position",
         rck_size_u: "Height in U (Units)",
         rck_width_mm: "Width in mm (millimeters)",
         rck_depth_mm: "Depth in mm (millimeters)",
         rck_create_title: "Create Rack",
         rck_update_title: "Update Rack",
         rck_delete_title: "Delete Rack",

         crg_create_title: "Create Cert. Registar",
         crg_update_title: "Update Cert. Registar",
         crg_delete_title: "Delete Cert. Registar",
         crg_name: "Registar Name",
         crg_uri: "Registar URL",
         crg_warn_days_margin: "Number of days before a WARN being issued",
         crg_error_days_margin: "Number of days before an ERROR being issued",
         crg_org_regex: "REGEX Pattern",

         cer_cn: "Certificate CN (Common Name)",
         cer_active: "Active",
         cer_masked: "Not visible on reports",
         cer_comments: "Comments",
         cer_registar: "Linked to Registar",
         cer_customer: "Linked to Customer",
         cer_create_title: "Declare Certificate",
         cer_update_title: "Update Certificate",
         cer_delete_title: "Delete Certificate",

         ced_active: "Active",
         ced_check_uri: "FQDN for Certificate Check",
         ced_check_server_or_ip: "FQDN or IP address",
         ced_starttls: "STARTTLS Mode",
         ced_auto_renew: "Auto-renewal",
         ced_disarm_warning: "Alarms off",
         ced_history: "Last days History",
         ced_cer_active: "Cert. active",
         ced_cer_masked: "Cert. masked",
         ced_cer_visible: "Cert. visible",
         ced_ced_active: "Depl. active",
         ced_create_title: "Declare Certificate Deployment",
         ced_update_title: "Update Certificate Deployment",
         ced_delete_title: "Delete Certificate Deployment",

         platform: "Platform",
         plf_code: "Platform Code",
         plf_name: "Platform Name",
         plf_ws_url_base: "Base URL for WS",
         plf_domain_radix: "Domain Radix",
         service: "Service",

         ldc_create_title: "Create LDAP Connector",
         ldc_update_title: "Update LDAP Connector",
         ldc_delete_title: "Delete LDAP Connector",
         ldc_create_title_auth: "Create an ID Management Connector",
         ldc_update_title_auth: "Update an ID Management Connector",
         ldc_delete_title_auth: "Delete an ID Management Connector",

         xxx_dyn_connector_name: "Connector Name",
         _xxx_ad_org_unit: "Relative OU *",
         _xxx_dyn_ldap_uri: "LDAP URI *",
         _xxx_dyn_ldap_basedn: "Server BaseDN *",
         _xxx_dyn_ldap_bind_login: "Bind Login *",
         _xxx_dyn_ldap_bind_password: "Bind Password *",
         _xxx_maxdbsize: "Max DBs size",
         _xxx_databases: "Exchange Databases",
         _xxx_servers: "Exchange Servers",

         lde_create_title: "Create LDAP Entry",
         lde_update_title: "Update Entry",
         lde_delete_title: "Delete LDAP Entry",
         lde_select_ldt_create: "You can create here an entity of the following type",
         lde_path_on_create: "Future LDAP entry will be stored in this Path",
         lde_root: "<root>",
         lde_cn: "Common Name (CN)",
         lde_givenname: "Firstname",
         lde_sn: "Lastname",
         lde_displayname: "Display Name",
         lde_mail: "EMail",
         lde_mail_and_upn: "EMail (and Login)",
         lde_groups: "Groups",
         lde_userprincipalname: "User Principal Name (UPN)",
         lde_userprincipalname: "User Principal Name (UPN)",
         lde_mail_and_userprincipalname: "Email and Login",
         lde_useraccountcontrols: "Selected Account Options",

         lde_ACCOUNTDISABLE: "Account disabled",
         lde_PASSWD_CANT_CHANGE: "User cannot change password",
         lde_DONT_EXPIRE_PASSWORD: "Password never expires",

         shc_compactcode: "Compact Code",
         shc_create_title: "Create a Shortcode",
         shc_update_title: "Update a Shortcode",
         shc_delete_title: "Delete a Shortcode",

         vlan: "VLAN",
         vla_code: "VLAN Code",
         vla_name: "VLAN Name",
         vla_vmware_name: "VLAN Name in ESXi",
         vla_id: "VLAN ID",

         cus_create_title: "Create Customer",
         cus_update_title: "Update Customer",
         cus_delete_title: "Delete Customer",
         cus_select_title: "Display Customer",
         cus_create_item: "Create a Customer",
         cus_name: "Company Name",
         cus_name_reseller: "Customer Reseller",
         cus_siret: "Registration ID",
         cus_vatnumber: "VAT European Number",
         cus_active: "Customer is Active",
         cus_blocked: "Customer is blocked",
         cus_code: "Internal Code",
         cus_quadratuscode: "Quadratus (Accounting) Code",
         cus_bm_id: "BM (Zoho) Customer ID",
         cus_bm_billing_id: "BM (Zoho) Billing Contact ID",
         cus_bm_shipping_id: "BM (Zoho) Shipping Contact ID",
         cus_bm_id_warning: "This Customer is not linked to BM (Prestashop). Before working on Contacts, update it please, close it, and reopen it.",
         cus_bm_ddoemail_id: "Presence of zoho@ddo.net in ZOHO",
         cus_main_domain: "Main DNS Domain",
         cus_glpi_id: "GLPI Entity ID",
         cus_invoice_default_reseller: "Invoices to Reseller",
         cus_can_change_dkim_selector: "Can change DKIM Selector",

         cut_name: "Type of Customer",

         plf_create_item: "Add a Platform",

         cusplf_create_title: "Attach a Platform",
         cusplf_update_title: "Update Attachment to Platform",
         cusplf_delete_title: "Delete Attachment to Platform",
         cusplf_select_title: "Display Attachment of Platform",

         cusser_create_title: "Attach a Service",
         cusser_update_title: "Update Attachment to Service",
         cusser_delete_title: "Delete Attachment to Service",

         messages_sent_monthly: "messages sent this month",
         messages_sent_last30: "messages sent last 30 days",
         megabytes_sent_monthly: "megabytes sent this month",
         megabytes_sent_last30: "megabytes sent last 30 days",

         xxx_maxusers: "Max number of Accounts",
         xxx_max_emails_per_month: "Max Emails sent per month",
         xxx_max_gigabytes_per_month: "Max Gigabytes sent per month",
         sasl_usernames: "Accounts",
         sasl_username: "Account",
         sasl_usernames_bareos: "BAREOS PC/Servers Names",
         sasl_username_bareos: "BAREOS PC/Server Name",
         emails_per_month: "Emails per month",

         xxx_sms_used : "SMS sent",

         xxx_inform_to_emails: "Customer Email(s)",
         xxx_inform_cc_emails: "Manager Email(s)",
         xxx_mailprofile_to: "Mall Template for Customer",
         xxx_mailprofile_cc: "Mail Template for Manager",
         xxx_suspend_on_threshold: "Suspend when limit(s) exceeded",
         xxx_inform_warn_level: "Threshold to trigger Emails",
         xxx_can_change_dkim_selector: "Can change DKIM Selector",

         xxx_bareosclientname: "Name of BAREOS 'Client'",

         usr_create_title: "Create Account",
         usr_update_title: "My informations",
         usr_delete_title: "Delete Account",
         usr_update_password: "Change my Password",
         usr_login: "ID (Login)",
         usr_firstname: "First Name",
         usr_lastname: "Last Name",
         usr_email: "Email",
         usr_displayname: "Display Name",
         usr_phone_mobile: "Mobile Phone",
         usr_upn_differs_from_email: "Change the Email and Align the Login with the new Email",

         equ_name: "Equipment Name",
         eqt_name: "Type",
         equ_positions: "Positions from botton to top",
         equ_on_front: "On Front",
         equ_create_title: "Create Equipment",
         equ_update_title: "Update Equipment",
         equ_delete_title: "Delete Equipment",

         smtppro_mails_month: "Mails this month",
         smtppro_mails_month_cumulative: "Cumulative Mails this month",
         smtppro_mails_last12months: "Mails on last 12 months",
         smtppro_bytes_month: "Volume this month",
         smtppro_bytes_month_cumulative: "Cumulative Volume this month",
         smtppro_bytes_last12months: "Volume on last 12 months",
         smtppro_mails_last30: "Mails on last 30 days",
         smtppro_bytes_last30: "Volume on last 30 days",
         smtppro_mails_month_short: "this month",
         smtppro_mails_month_cumulative_short: "Cumulative, this month",
         smtppro_mails_last12months_short: "on last 12 months",
         smtppro_bytes_month_short: "this month",
         smtppro_bytes_month_cumulative_short: "Cumulative, this month",
         smtppro_bytes_last12months_short: "on last 12 months",
         smtppro_mails_last30_short: "on last 30 days",
         smtppro_bytes_last30_short: "on last 30 days",

         smtppro_mails_sent: "Sent",
         smtppro_mails_bounced: "Bounced",
         smtppro_mails_expired: "Expired",
         smtppro_mails_deferred: "Deferred",

         smspro_sms_month: "sms this month",
         smspro_sms_month_cumulative: "Cumulative sms this month",
         smspro_sms_last12months: "sms on last 12 months",
         smspro_bytes_month: "Volume this month",
         smspro_bytes_month_cumulative: "Cumulative Volume this month",
         smspro_bytes_last12months: "Volume on last 12 months",
         smspro_sms_last30: "sms on last 30 days",
         smspro_bytes_last30: "Volume on last 30 days",
         smspro_sms_month_short: "this month",
         smspro_sms_month_cumulative_short: "Cumulative, this month",
         smspro_sms_last12months_short: "on last 12 months",
         smspro_bytes_month_short: "this month",
         smspro_bytes_month_cumulative_short: "Cumulative, this month",
         smspro_bytes_last12months_short: "on last 12 months",
         smspro_sms_last30_short: "on last 30 days",
         smspro_bytes_last30_short: "on last 30 days",

         smtppro_search_and_export: "Search with above criterias, and Export results in CSV",
         smtppro_search_and_export: "Directly Export a given month, with above criterias, in CSV",

         smspro_sms_sent: "Sent",
         smspro_sms_bounced: "Bounced",
         smspro_sms_expired: "Expired",
         smspro_sms_deferred: "Deferred",

         backupbareos_jobs_month: "Jobs this month",
         backupbareos_jobs_month_cumulative: "Cumulative Jobs this month",
         backupbareos_jobs_last12months: "Jobs on last 12 months",
         backupbareos_files_month: "Files this month",
         backupbareos_files_month_cumulative: "Cumulative Files this month",
         backupbareos_files_last12months: "Files on last 12 months",
         backupbareos_bytes_month: "Volume this month",
         backupbareos_bytes_month_cumulative: "Cumulative Volume this month",
         backupbareos_bytes_last12months: "Volume on last 12 months",

         backupbareos_jobs_day_short: "this day",
         backupbareos_jobs_month_short: "this month",
         backupbareos_jobs_month_cumulative_short: "Cumulative, this month",
         backupbareos_jobs_last12months_short: "on last 12 months",
         backupbareos_jobs_last30_short: "on last 30 days",
         backupbareos_files_day_short: "this day",
         backupbareos_files_month_short: "this month",
         backupbareos_files_month_cumulative_short: "Cumulative, this month",
         backupbareos_files_last12months_short: "on last 12 months",
         backupbareos_files_last30_short: "on last 30 days",
         backupbareos_bytes_day_short: "this day",
         backupbareos_bytes_month_short: "this month",
         backupbareos_bytes_month_cumulative_short: "Cumulative, this month",
         backupbareos_bytes_last12months_short: "on last 12 months",
         backupbareos_bytes_last30_short: "on last 30 days",

         backupbareos_jobs_done: "Done",
         backupbareos_jobs_cancelled: "Cancelled",
         backupbareos_jobs_failed: "Failed",
         
         search_xxx_sasl_usernames: "Account Name",
         search_radix_from: "<First characters of Sender's Email>",
         
         search_radix_from_recipient: "<First numbers of Recipient's number phone>",
         search_radix_from_sentfromip: "<First numbers of Sent from IP>",
         search_radix_from_sendingname: "<First characters of Sending name>",

         search_radix_to: "<First characters of Recipient's Email>",
         search_domain_from: "<First characters of Sender's Email Domain>",
         search_domain_to: "<First characters of Recipient's Email Domain>",
         choose_dropdown_graph: "Choose a Graph",
         choose_dropdown_account: "Choose an Account",
         search_start_with: "Starts with :",
         search_sent_from_ip: "Enter your fully IP address :",
         search_results_hasbeendelivered: "HAS BEEN DELIVERED",
         search_results_hasbeenrejected: "HAS BEEN REJECTED",
         search_results_hasexpired: "HAS EXPIRED",
         search_results_hasbeendeferred: "HAS BEEN DELAYED",
         search_results_comments: "Outgoing mail from <strong>'%s'</strong> to <strong>'%s'</strong> <mark>%s</mark>",
         search_results_comments_clean: "Outgoing mail from '%s' to '%s' %s",
         
         search_results_hasbeendoned: "HAS BEEN DONED",
         search_results_hasbeencancelled: "HAS BEEN CANCELLED",
         search_results_hasbeenfailed: "HAS BEEN FAILED",

         search_log_function: "Function",
         search_log_action: "Action",
         search_log_cus_activated: "Search is done only for Customer %s",
         search_log_cus_deactivated: "Search is done for all Customers",

         ser_certificates_explanations_create: "By clicking on 'Create' button, you are going to link this Customer to the Certificates Monitoring System. This system monitors all declared Certificates, their deployments on servers, and their due date",
         ser_certificates_explanations_update: "Nothing to change...",
         ser_certificates_explanations_delete: "By clicking on 'Delete' button, you are going to unlink this Customer to the Certificates Monitoring System. This system will no more monitor all declared Certificates, their deployments on servers, and their due date",

         ctc_name_general: "Main Contact",
         ctc_name_invoicing: "Contact for Invoicing",
         ctc_name_shipping: "Contact for Shipping",
         ctc_create_title: "Create Contact",
         ctc_update_title: "Update Contact",
         ctc_delete_title: "Delete Contact",
         ctc_organizationname: "Position",
         ctc_firstname: "First Name",
         ctc_lastname: "Last Name",
         ctc_addr_line1: "Line 1",
         ctc_addr_line2: "Line 2",
         ctc_addr_zipcode: "Zip Code",
         ctc_addr_city: "City",
         ctc_addr_country: "Country",
         ctc_affectations: "Affectations",
         ctc_create_contact: "Create Contacts",
         ctc_is_invoicing: "Usable for invoicing",
         ctc_is_shipping: "Usable for shipping",
         ctc_phone_fixed_phone: "Landline Number",
         ctc_phone_cell_phone: "Cellular Number",
         ctc_vatnumber: "EU intra-Community VAT number",
         ctc_bm_id: "BM (ZOHO) Contact ID",
         ctc_bm_address_billing_id: "BM (ZOHO) Billing Address ID",
         ctc_bm_address_shipping_id: "BM (ZOHO) Shipping Address ID",

         ctc_billing_same_as_general: "Same address as 'General'",
         ctc_shipping_same_as_billing: "Same address as 'Billing'",
         ctc_shipping_same_as_general: "Same address as 'General'",

         ctt_name: "Title",

         prc_active: "Active",
         prc_internalcode: "Internal Code",
         prc_name: "Category Name",
         prc_visible_on_front: "Visible on Front-Office",
         prc_for_logged_customer: "Only for logged Customers",
         prc_create_title: "Create Category",
         prc_update_title: "Update Category",
         prc_delete_title: "Delete Category",
         prc_visible_on_front: "Visible sur Front-Office",
         prc_for_logged_customer: "Seulement pour client connecté",

         pro_active: "Active",
         pro_is_periodic: "Periodic",
         pro_visible_on_front: "Visible on Front-Office",
         pro_default_plan: "Default Plan",
         pro_price: "Price (VAT)",
         pro_setup_price: "Setup Price (VAT)",
         pro_yearly_price: "Price (VAT) (annual)",
         pro_yearly_setup_price: "Setup Price (VAT) (annual)",
         pro_image_link: "Image",
         pro_name: "Product Name",
         pro_flags: "Flags",
         pro_reseller_nrr_discount: "NRR Reseller Discount",
         pro_reseller_mrr_discount: "MRR Reseller Discount",
         pro_create_title: "Create Product",
         pro_update_title: "Update Product",
         pro_delete_title: "Delete Product",
         producttype: "ZOHO Product Type",
         productcategory: "Parent Category",

         xxx_method: "Counting Method",
         method_recurrent: "Method by subscription (recurrent)",
         method_quota: "Method by quota (buy)",

         inv_export_to_accounting: "Mark each line as 'exported' to accounting system",
         inv_export_include_accounting: "Even if line has been 'exported' to accounting system, include it in output",
         explanation_sync_from_zoho_invoices: "Before clicking on 'Convert', it could be necessary to re-sync invoices/credit-notes from ZOHO",
         explanation_select_and_pay_invoices: "You may check one or more due Invoices, and click on the Button 'Pay by Card",
         selected_amount: "Selected Invoices Amount",
         due_amount: "Due Invoices Amount",

         dkr_create_title: "Create DKIM onto Internet Domain Name",
         dkr_declare_title: "Declare DKIM onto Internet Domain Name",
         dkr_update_title: "Update DKIM onto Internet Domain Name",
         dkr_delete_title: "Delete DKIM onto Internet Domain Name",
         dkr_declare_item: "Declare DKIM onto Internet Domain Name",
         dkr_domainname: "Internet Domain Name",
         dkr_selector: "DKIM Selector",

         sla_computed: "SLA Computed",
         sla_active: "SLA Active",
         sla_positive: "SLA Positive",
         sla_name: "Texte SLA",
         sla_duration: "Durée SLA",

         level_sla: "SLA",
         sla_currentmonth: "this Month",
         sla_last12months: "on last 12 Months",

         dkim_last_check: "Last Check at",
      },

      hints: {
         _code: "Unique ID",
         _name: "Readable Name",
         _desc: "Full Description",

         signin_email: "must be your Email",
         signin_password: "must be your Password",
         change_password1: "Your new Password must have a minimal length of 8 characters, and 3 of the 4 following criteria :<ul><li>At least one lowercase character,</li><li>At least one UPPERCASE character,</li><li>At least one digit,</li><li>At least one special character in the following list : ? ! & §,</li></ul>",
         change_password2: "",

         net_cidr: "in the format x.x.x.x/y",
         net_deployable: "can generate IP addresses",
         network_subnet_regex_mask: "A regex string to generate some, but not all, subnets",

         dtc_address: "Postal Address",

         dtr_position: "Rank of Row in Datacenter",

         dtc_position: "Rank of Rack in Row",

         rck_size_u: "Currently, 42 U",
         rck_width_mm: "Currently 600 (mm)",
         rck_depth_mm: "Currently 1000 (mm), 800, 600, ...",

         xxx_connector_name: "Connector Name, when Platforms are dynamic, to distinguish them",
         xxx_ad_org_unit: "Organization Unit (relative to server base), in format <OU>/<OU>/OU ...",
         xxx_dyn_ldap_uri: "URI to access LDAP server, in format ldap://... or ldaps://...",
         xxx_dyn_ldap_basedn: "Base DN of server, in format OU=...,DC=...,DC=...,DC=...",
         xxx_dyn_ldap_bind_login: "Admin User to bind to server. For Active Directory Server, in format <DOMAIN>\<User>, or <UserPrincipalName>",
         xxx_dyn_ldap_bind_password: "Password of Admin User",
         lde_cn: "Common Name (CN)",
         lde_select_ldt_create: "You can create here an entity of the following type",
         lde_path_on_create: "Future LDAP entry will be stored in this Path",
         lde_givenname: "Firstname",
         lde_sn: "Lastname",
         lde_displayname: "Display Name",
         lde_distinguishedname: "DistinguishedName (DN)",
         lde_code: "ID in FQDN format",
         lde_mail_and_upn: "Email will also be used as Login (UPN)",
         lde_mail: "Email associated to this Account",
         
         xxx_inform_to_emails: "List of Emails, separated by ','. Each Email will be informed when one threshold is exceeded",
         xxx_inform_cc_emails: "List of Emails, separated by ','. Each Email will be informed when one threshold is exceeded",
         xxx_suspend_on_threshold: "Account is suspended if one threshold is exceeded. Account is reactivated on first day of next month",
         xxx_inform_warn_level: "Email is sent only if current level is equal to or higher than this level",

         cer_comments: "Comments on this Certificates",

         ced_check_uri: "URL de check du Certificat",
         ced_check_server_or_ip: "FQDN or IP address",
         ced_starttls: "STARTTLS Mode",
         ced_auto_renew: "Auto-renewal",
         ced_disarm_warning: "Alarms off",

         crg_name: "Registar Name",
         crg_uri: "Registar Website URL",
         crg_warn_days_margin: "Number of days before a WARN being issued",
         crg_error_days_margin: "Number of days before an ERROR being issued",
         crg_org_regex: "REGEX Pattern, generally a string with several | characters, for separating each possibility",

         vla_id: "VLAN ID, in range 0..4095",
         vla_vmware_name: "VLAN Name, declared in all ESXi servers, managed by vCenter or not",

         usr_login: "This ID must be UNIQUE",
         usr_displayname: "Generally : <LASTNAME>, <Firstname>, or <Firstname> <LASTNAME>",
         usr_email: "Your Email which can receive notifications",
         usr_phone_mobile: "This phone number could be used during a control on a connection. A security code could be send by SMS on this phone.",
         usr_upn_differs_from_email: "Login and Email are often the same. But you can dissociate both. If you check it, changing the Email will imply chaing the Login. You will be disconnected, and you'll have to reconnect after that.",

         search_xxx_sasl_usernames: "SMTP-PRO Account Name",
         search_radix_from: "Starting characters from first part of Sender's email (part before @), in lowercase. Example : 'joh' for 'john.doe@example.com'",
         search_radix_to: "Starting characters from first part of Recipient's email (part before @), in lowercase. Example : 'joh' for 'john.doe@example.com'",
         search_domain_to: "Starting characters from second part of Sender's email (part after @, i-e the 'domain'), in lowercase. Example : 'exampl' for 'john.doe@example.com'",
         search_domain_to: "Starting characters from second part of Sender's email (part after @, i-e the 'domain'), in lowercase. Example : 'exampl' for 'john.doe@example.com'",

         cus_name: "Company Name/Customer Name. Must be equal or close to the official name of the Customer",
         cus_code_create: "Alphanumeric Code (A-Z,0-9, and '-'). This code will be automatically generated by system, derivated from Company Name. It can be manually changed by clicking on the 'Edit' icon. Generated codes are checked to non-existence, manually edited codes are not checked",
         cus_code_update: "Alphanumeric Code (A-Z,0-9, and '-'). This code can no more be changed.",
         cus_siret: "Company Business ID",
         cus_vatnumber: "European VAT Number of the Company",
         cus_main_domain: "Main DNS Domain (without @)",

         pro_reseller_nrr_discount: "Reseller Discount for Non-Recurrent",
         pro_reseller_mrr_discount: "Reseller Discount for monthly Recurrent",

         xxx_bareosclientname: "Name of the 'Client' entity in BAREOS configuration files. This name will be used as a link with backup feedbacks done by BAREOS in name of this 'Client'",

         dkr_domainname: "You must have control on the DNS of this Domain Name, to allow creation of a TXT record for DKIM. Any domain name is authorized : example.com, your-domain.us, ...",
         dkr_selector: "Any combination of characters, numbers, ... compatible with DNS naming convention",

      },

      messages: {
         password_not_complex: "The password is not enough complex",
         _spf_full_settings_1: "<strong>SPF (Sender Policy Framework)</strong> is a email authentication method described here : <a href='https://en.wikipedia.org/wiki/Sender_Policy_Framework' target='_blank'><strong>Wikipedia</strong></a>",
         _spf_full_settings_2: "To apply SPF on SMTP-PRO for your Internet domain, you just have to create or update a DNS record, of TXT type, on you Internet domain. For example : example.com, the simpliest writing, for allowing SMTP-PRO to send your emails, is :",
         _spf_full_settings_3: "<strong><pre>v=spf1 include:_spf.smtp-pro.com ~all</pre></strong>",
         _spf_full_settings_4: "If you already have a SPF record, just add into it : <strong><pre>include:_spf.smtp-pro.com</pre></strong>",

         _dkim_full_settings_1: "<strong>DKIM (DomainKeys Identified Mail)</strong> is a other email authentication method described here : <a href='https://en.wikipedia.org/wiki/DomainKeys_Identified_Mail' target='_blank'><strong>Wikipedia</strong></a>",
         _dkim_full_settings_2: "To apply DKIM on SMTP-PRO for your Internet domain(s), you just have to create a DNS record, of TXT type, for each of your Internet domains. You are allowed to create DKIM informations for up to 10 domains of yours. This creation is a 2-steps process :",
         _dkim_full_settings_3: "<ul><li>Create the DKIM private your Internet domain on our system</li><li>Declare a TXT record in your DNS console for this Internet domain</li><li>Check and Validate the DKIM</li></ul>",
         _dkim_full_settings_4: "Remember : SMTP-PRO does not restrict you to one domain, when sending emails, but you have to declare all (up to 10) domains in our DKIM processes to improve your deliverability",

         _dkim_record_explanation_1: "Please, declare a TXT record for your domain : <strong><pre>%s</pre></strong>, having a key : <strong><pre>%s</pre></strong>, and having a value :",
         _dkim_record_explanation_2: "This last value has been copied to your clipboard.",

         inv_tracking_message_already_flagged: 'Invoice %s already exported. Row skipped',
         inv_tracking_message_now_flagged: 'Invoice %s now flagged as exported',
         inv_tracking_message_row_included: 'Invoice %s re-included in results',
         inv_tracking_message_not_found: 'Invoice %s not found',

      },

      tooltips: {
         edit: "Edit",
         delete: "Delete",
         open: "Open",
         close: "Close",
         details: "Details",
         create: "Create",
         attach: "Attach",
         detach: "Detach",
         copy: "Copy",
         clipboard: "Copy to clipboard",
         dns_validated: "DNS Record validated",
         dns_not_validated: "DNS Record NOT validated",
      },

   },

   "fr": {
      nav: {
         dashboard: "Tableau de bord",
         login: "Connexion",
         logout: "Déconnexion",
         admin: "Administration",
         ddo_extranet: "EXTRANET DDO",
         mallatius_extranet: "EXTRANET MALLATIUS",
         plf_admin: "Administration",
         plf_exchange: "Plateforme Exchange",
         reseller: "Revendeurs",
         myprofile: "Mon Profil",
         catalog: "Catalogue",
         catalogtest:"Catalog Test" ,
         mycompany: "Infos Société",
         infra: "Infrastructure",
         identities: "Identités",
         settings: "Réglages",
         crg: "Registres de certificats",
         cer: "Certificats",
         cus: "Clients",
         net: "Réseaux",
         vla: "VLANs",
         ipa: "Adresses IP",
         dtc: "Datacenters",
         equ: "Equipements",
         dtr: "Rangées",
         rck: "Baies",
         shc: "Raccourcis",
         plf: "Plateformes",
         prc: "Produits",
         inv: "Factures",
         product: "Catégories et Produits",
         monitoring: "Monitoring",
         monitoring_log: "Logs",
         monitoring_racks_in_dc: "Baies en DC",
         monitoring_certificatedeployments: "Certificats déployés",
         monitoring_customercontacts: "Contacts Clients",
         monitoring_customerservicesmtppro: "Service SMTP-PRO",
         monitoring_customerservicesmspro: "Service SMS-PRO",
         monitoring_customerservicebackupbareos: "Service Backup BAREOS",
         monitoring_logs: "Logs",

         zoho2prestige: "Conversion ZOHO vers PRESTIGE",
         zohoconv: "Zoho2Prestige",
         monitoring_customers: "Service CLIENTS",
         monitoring_customerresellers: "Service CLIENTS REVENDEURS",

         dtc_one : "Datacenter",
         dtr_one : "Rangée",
      },

      links: {
         manage_smtppro: "Gestion de SMTP-PRO",
         manage_smspro: "Gestion de SMS-PRO",
      },

      buttons: {
         create_item: "Créer un Elément",
         create_network: "Créer un Réseau",
         generate_ipa: "IPv4",
         display: "Afficher",
         close: "Fermer",
         create: "Créer",
         edit: "Editer",
         modify: "Modifier",
         update: "Enregistrer",
         delete: "Supprimer",
         cancel: "Annuler",
         confirm: "Confirmer",
         login: "Connexion",
         send: "Envoyer",
         convert: "Convertir",
         ok: "OK",
         to_clipboard: "Vers presse-papiers",
         create_ldapconnector: "Attacher un nouveau gestionnaire d'Identité",
         generate_password: "Générer un Mot de Passe",
         attach_platform: "Attacher une Plateforme",
         attach_this_platform: "Attacher cette Plateforme",
         attach_this_service: "Attacher ce Service",
         resetpassword: "Changer",
         search: "Rechercher",
         create_contact: "Créer un Contact",
         export_csv: "Exporter en fichier CSV",
         sync_from_zoho: "Re-Synchro depuis ZOHO",
         back_catalog: "Retour",
         category_catalog: "Catégories",
         plans_catalog: "Abonnements",
         order_catalog: "Commander",
         pay_by_card: "Payer par Carte Bancaire",
         check_dns_and_validate: "Vérifier les DNS et Valider", 
         export_month_csv_with_status: "Exporter en CSV pour le Statut '%s', pour la période : %s", 
         export_month_csv: "Exporter en CSV, pour la période : %s", 
      },

      titles: {
         crg: "Liste des Registres de Certificat",
         dtc: "Liste des Datacenters",
         dtr: "Liste des Rangées",
         rck: "Liste des Baies",
         net: "Liste des Réseaux",
         vla: "Liste des VLAN",
         ldc: "Liste des Gestionnaires d'Identité",
         shc: "Liste des Raccourcis",
         cus: "Liste des Clients",
         equ: "Liste des Equipements",
         ced: "Liste des Certificats et de leurs Déploiements",
         prc: "Catégories et Produits",
         pro: "Produits",
         inv: "Factures",
         dkr: "Enregistrements DKIM",
         sla: "SLA (Service Level Agreement)",
         sla_short: "SLA",
         search_mails_out: "Recherche de mails sortants",
         search_sms_out: "Recherche de sms",
         search_jobs: "Recherche de jobs",
         search: "Recherche",
         graphs: "Graphes",
         zoom_graph: "Zoom sur le Graphe",
         for_account: "pour le compte",
         smtppro_details: "Détails",
         smspro_details: "Détails",
         backupbareos_details: "Détails",
         tile_certs: "Certificats SSL",
         tile_smtppro: "SMTP-PRO",
         tile_smspro: "SMS-PRO",
         tile_backupbareos: "BAREOS",
         synthesis: "Synthèse",
         prices: "Prix",
         _DEVELOPMENT: "DÉVELOPPEMENT",
         invoices: "Factures",
         orders: "Commandes",
         payment_by_card: "Paiement par Carte Bancaire",
         settings: "Réglages",
         settings_spf_dkim: "Réglages SPF et DKIM",
         _spf_full_settings: "Réglages SPF",
         _dkim_full_settings: "Réglages DKIM",
         _dns_record_to_create: "Enregistrement DNS à créer",
      },

      subtitles: {
         cer: "Liste des certificats SSL fourni par le Registre %s",
         ced: "List des Déploiements du Certificat %s",
         dtr: "Liste des Rangées du Datacenter %s",
         rck: "Liste des Baies de la Rangée %s",
         equ: "Liste des Equipements dans la Baie %s",
         ipa: "Tableau des adresses IP du Bloc Réseau %s",
         lde: "Gestion des Identités de '%s'",

         properties: "Propriétés",
         contacts: "Contacts",
         postal_address: "Adresse Postale",
         phones: "Téléphones",
         phone_fixed: "Fixe",
         phone_cell: "Mobile",
         properties_bm: "Propriétés Compta+ZOHO",
         properties_glpi: "Propriétés GLPI",
         properties_smtppro: "Propriétés SMTP-PRO",

         monitoring_unknown_codes_this_month: "Codes inconnus ayant eu de l'activité ce mois-ci",
         monitoring_known_codes: "Codes connus",

         counting_method: "Méthode de décomptage",

         xxx_platforms: "Liste des Plateformes du Client %s",

         ldc_section_platform: "Plateforme",
         ldc_section_ou: "OU du Client",
         ldc_section_dynamic: "Serveur d'Authentification",
         ldc_section_auth: "Informations d'Authentification",
         ldc_section_exchange: "Informations Exchange",
         lde_useraccountcontrols: "Options de Compte",
         lde_accountname: "Identifiants de compte",
         lde_userprincipalname: "Nom de compte pour ouvrir une session (UserPrincipalName)",
         lde_samaccountname: "Nom de compte avant Windows 2000 (SamAccountName)",

         lde_properties: "Propriétés",
         lde_member_of: "Membre de",

         shc_macros: "Macros disponibles",
         shc_steps: "Etapes",

         equ_properties: "Propriétés",
         equ_positions: "Emplacement dans la Baie",
         equ_rack: "Rattaché à la Baie",

         crg_margins: "Seuils de déclenchement",
         cer_properties: "Propriétés",
         cer_attachments: "Rattachements",

         settings: "Réglages",
         addaccount: "Ajouter un Compte",
         listaccount: "Compte existant",
         listaccounts: "Comptes déjà enregistrés",
         listpatterns: "Motif REGEX des noms de CA",
         addbareosclientname: "Nom de l'entité 'Client'",

         inform_by_mail_of_excess: "Envoyer les informations de dépassement par mail",
         inform_by_mail_of_backups: "Envoyer les informations des backups par mail",
         inform_by_mail_of_certificates: "Envoyer les informations des certificats par mail",
         inform_to_customer: "Au Client",
         inform_to_manager: "Au Manager",

         filters: "Filtres",

         ced_certificate_part: "Pour le Certificat",
         ced_deployment_part: "Pour le premier déploiement de ce Certificat",

         search_criteria: "Critères de recherche", 
         search_results: "Résultats de la recherche", 
         search_account: "Au titre du Compte", 
         search_status: "Messages avec le Statut", 
         search_status_sms: "SMS avec le Statut",
         search_status_jobs: "Jobs avec le Statut", 
         search_daterange: "Date", 
         search_selecteddaterange: "Date(s) sélectionnée(s)", 
         search_sender: "Expéditeur", 
         search_recipient: "Destinataire",
         search_sentfromip: "Emis depuis IP",
         search_sendingname: "Nom d'envoi",
         synthesis_count_per_status_on_last_days: "Comptage des mails envoyés par statut de délivrance, sur les 14 derniers jours",
         synthesis_count_sms_per_status_on_last_days: "Comptage des SMS envoyés par statut de délivrance, sur les 7 derniers jours",
         synthesis_count_jobs_per_status_on_last_days: "Comptage des jobs par statut, sur les 7 derniers jours", 

         contact_general: "Contact Principal",

         settings_zoho: "Réglages ZOHO",
         settings_local: "Réglages locaux",

         plans: "Déclinaisons",
         html_presentation: "Présentation HTML",

         invoices: "Factures",
         orders: "Commandes",
         identity: "Identité",
         ctc_general: "Contact Général",
         ctc_billing: "Contact Facturation",
         ctc_shipping: "Contact Livraison",

         sla_computed: "SLA Calculé",
         sla_flags: "Typologie SLA",
         sla_datetime_interval: "Intervalle de temps du SLA",
         cus_plf_bindings: "Relié à un Client ou une Plateforme",

         equ_networks: "Informations cartes réseaux",
      },

      headers: {
         actions: "Actions",
         action_refresh: "Refresh",
         code: "Code",
         name: "Nom",
         description: "Description",
         created_on: "Créé le",
         updated_on: "Mis à jour le",
         alternative_or: "OU",

         _details: "Détails",
         _data: "Informations",
         _customer: "Client",
         _account: "Compte",
         _thresholds: "Seuils",
         _counters: "Compteurs",
         _status: "Statut",
         _visible: "Visible",
         _default: "Défaut",
         _pdf_link: "Lien PDF",
         _refreshed_on: "Rafraichi le",
         _exported: "Exporté",

         cer: "Certif.",
         ipa: "Adr. IP",
         dtr: "Rangées",
         rck: "Baies",
         lde: "Identités",

         cer_cn: "Certificat (CN)",
         ced_check_uri_and_code: "Déploiement (URI+Code)",

         xxx_connector_name: "Plateforme d'Identités",

         flags: "Drapeaux",
         ipa_affectation: "Affectations IP",
         cidr: "CIDR",

         plf_name: "Plateforme",
         platforms: "Plateformes",
         vla_id: "VLAN",
         xxx_steps: "Etapes",

         messages: "Messages",
         sms: "SMS",
         megabytes: "Mega-octets",
         files: "Fichiers",
         volume: "Volume",

         equ_position_from: "Emplacement",
         equ_count: "Equipements",
         equ_location: "Baie",

         prc_name: 'Nom Catégorie',
         prc_level: 'Niveau',
         prt_bm_entity_name: 'Nom entité ZOHO',
         pro_name: "Nom Product",

         datetime: "Jour+Heure",
         datetime_gmt: "Jour+Heure (GMT)",
         messageid: "ID de Message",
         jobid: "ID de Job",
         jobname: "Nom du Travail (Job)",
         sendername: "Nom d'envoi",
         servername: "Serveur",
         recipient: "Destinataire",
         comments: "Commentaires",
         traces: "Traces",
         status: "Statut",
         smsconsumed: "SMS consommés",
         addressrequestip: "Emis depuis IP",
         errormessage: "Message: éventuel message d'erreur",
         count_submitted: "Soumis(submitted)",

         log_event: "Date+Heure",
         log_ipv4: "Depuis l'IPv4",
         log_function: "Fonction",
         log_action: "Action",
         log_traces_json_lite: "Plus d'infos...",

         synthesis_date: "Date", 
         synthesis_account: "Compte", 
         synthesis_sent: "Délivrés (sent)", 
         synthesis_bounced: "Rejetés (bounced)", 
         synthesis_expired: "Expirés (expired)", 
         synthesis_deferred: "Retardés (deferred)", 
         synthesis_graph: "Graphe", 

         synthesis_done: "Traités (Done)", 
         synthesis_failed: "Echoués (Failed)", 
         synthesis_canceled: "Annulés (Canceled)", 

         deliverability_average_time: "Délivrabilité (temps moyen)",
         deliverance_average_time: "Délivrance (temps moyen)",

         synthesis_day: "Jour du résultat (Result Day)",
         synthesis_backup_account: " Compte du backup (Backup Account)",
         synthesis_backup_ok: " Nombre de jobs ayant fini OK (Done)", 
         synthesis_backup_cancelled: " Nombre de jobs annulés (Cancelled)", 
         synthesis_backup_failed: " Nombre de jobs plantés (Failed)", 

         ord_starts_at: "Début",
         pro_name: "Nom du Produit",
         ord_code: "Numéro Commande",
         ors_code: "Statut Commande",
         ord_total_price: "Prix",

         cus_name: "Nom Client",
         inv_code: "Numéro facture",
         inv_date: "Date de facture",
         inv_is_invoice: "Nature",
         inv_bm_specific_fields: "Période",
         ins_name: "Statut",
         inv_signed_total_price: "Montant",

         dkr_domainname: "Nom de domaine",
         dkr_publickey: "Clé Publique DKIM",

         sla_name: "Texte SLA",
         sla_active: "Drapeaux SLA",
         sla_event_start: "Intervalle Début/Fin",
      },

      utils: {
         MB: "MO",
         Mbytes: "Mo",
         mb: "mo",
         GB: "GO",
         Gbytes: "Go",
         gb: "go",
         MBytes: "Moctets",
         megabytes: "mega-octets",
         _netprice: "hors taxe",
         _grossprice: "toutes taxes comprises",
         _bp: "ht",
         _gp: "ttc",
         _BP: "HT",
         _GP: "TTC",
         _BP_pm: "HT par mois",
         _bp_pm: "ht par mois",
         _BP_py: "HT par an",
         _bp_py: "ht par an",
         _datefrom: "Du ",
         _dateto: "Au ",
      },

      texts: {
         loading: "Chargement",
         requiredfield: "indique un champ obligatoire",
         signin_title: "Connexion",
         signin_subtitle: "Vous devez vous identifier !",
         signin_login: "Compte",
         signin_email: "Email",
         signin_password: "Mot de Passe",
         signin_forgot_password: "Mot de passe oublié?",
         signup_title: "Ouvrir un compte",
         signup_new_website: "Bienvenue sur my ",
         signup_explanations: "Déjà client ? Connectez-vous pour retrouver vos services.<br/><br/>Vous n'êtes pas encore client et vous êtes intéressés par nos offres.<br/>Contactez-nous :<br/>",
         signup_explanations_1_ddo: "Déjà client ? Connectez-vous pour retrouver vos services.",
         signup_explanations_2_ddo: "Vous n'êtes pas encore client et vous êtes intéressés par nos offres.<br/>Contactez-nous :<br/>",
         signup_explanations_1_smtppro: "Déjà client ? Connectez-vous pour retrouver vos services SMTP-PRO.",
         signup_explanations_2_smtppro: "Vous n'êtes pas encore client et vous êtes intéressés par nos Produits et Services.<br/>Cliquez ci-dessous :<br/>",
         signup_register_now: "S'inscrire maintenant",
         switch_customer: "Changement de Client",
         session_itself: "Mes propres informations",
         change_password1: "Nouveau mot de passe",
         change_password2: "Répéter le nouveau mot de passe",
         forgotpassword_title: "Mot de passe oublié ?",
         forgotpassword_subtitle: "Indiquez votre code d'accès, et un lien vous sera envoyé sur l'email associé, pour définir un nouveau mot de passe",
         forgotpassword_return: "Retour Connexion",
         resetpassword_title: "Changer votre Mot de passe",
         resetpassword_subtitle: "Vous pouvez changer votre Mot de passe en remplissant les 2 champs ci-dessous et en cliquant sur 'Changer' :",
         list_mode: "Mode Liste",
         list_certificates: "Certificats existants",
         list_registars: "Registres existants",
         certificates_certificates_month: "Certificats surveillés",
         accounts: "aucun compte | 1 compte | {count} comptes",
         certificates_list: "Certificats",

         countrySelectorLabel: "Code Pays",
         countrySelectorError: "Choisissez un pays",
         phoneNumberLabel: "Numéro de téléphone",
         example: "Exemple",

         invoice: "Facture",
         creditnote: "Avoir",

         method_recurrent: "Recurrent (Monthly) Method",
         method_quota: "Quota Method",
         method: "Method",

         _required: "Champ obligatoire",
         _code: "Code",
         _required_code: "Code*",
         _name: "Nom",
         _required_name: "Nom*",
         _desc: "Description",
         _email_format: "De la forme : <nom>@<domaine>.<extension>. Par exemple : contact@exemple.com",
         _bm_name_format: "Doit uniquement contenir des caractères alphabétiques, pas de chiffre ni de caractères spéciaux",
         _domainname_format: "De la forme : <domaine>.<extension>. Par exemple : domaine.com",
         _email: "Email",
         _job: 'Travail',
         _emails: "Messages",
         _sms: "SMS",
         _jobs: "Travaux",
         _files: "Fichiers",
         _active: "Actif",
         _inactive: "Inactif",
         _activated: "Activé",
         _deactivated: "Désactivé",
         _status: "Statut",
         _expired: "Expiré",
         _expired_since: "Expiré depuis le",
         _expires_on: "Expire le",
         _suspended: "Suspendu",
         _suspended_since: "Suspendu depuis le",
         _minimal_root_path: "Vous avez indiqué un chemin plus court que le minimum autorisé",
         _firstname: "Prénom",
         _lastname: "Nom",
         _level: "Niveau",
         _order: "Rang",
         _orderpath: "Chemin de tri",

         _firstname: "Prénom",
         _lastname: "Nom",

         _cookies_law_1: "Ce site utilise des cookies de session pour une meilleure utilisation",
         _cookies_law_2: "Le seul cookie externe est celui de Google Analytics",
         _cookies_law_3: "Vouluez-vous continuer ?",
         _cookies_law_accept: "J'accepte",
         _cookies_law_deny: "Je refuse",

         equipmenttype: "Type d'Equipement",
         equipment: "Equipement",

         level_ok: "Niveau OK",
         level_warning: "Niveau Avertissement",
         level_error: "Niveau Erreur",
         level_ok_short: "OK",
         level_warning_short: "Avertissement",
         level_error_short: "Erreur",

         net_ipv4: "est IP v4",
         net_ipv6: "est IP v6",
         net_public: "est public",
         net_deployable: "déployable",
         net_create_title: "Création d'un Réseau",
         net_update_title: "Mise à jour du Réseau",
         net_delete_title: "Suppression du Réseau",

         dtc_address: "Adresse postale",
         dtc_create_title: "Création d'un Datacenter",
         dtc_update_title: "Mise à jour du Datacenter",
         dtc_delete_title: "Suppression du Datacenter",

         dtr_position: "Position",
         dtr_create_title: "Création d'une Rangée de Baies",
         dtr_update_title: "Mise à jour d'une Rangée de Baies",
         dtr_delete_title: "Suppression d'une Rangée de Baies",
         dtr_location: "Emplacement",

         rck_position: "Position",
         rck_size_u: "Taille (U)",
         rck_width_mm: "Largeur en mm (millimètres)",
         rck_depth_mm: "Profondeur en mm (millimètres)",
         rck_create_title: "Création d'une Baie",
         rck_update_title: "Mise à jour d'une Baie",
         rck_delete_title: "Suppression d'une Baie",

         crg_create_title: "Création d'un Registre de Certificat",
         crg_update_title: "Mise à jour du Registre de Certificat",
         crg_delete_title: "Suppression du Registre de Certificat",
         crg_name: "Nom du Registre",
         crg_uri: "URL du site Web",
         crg_warn_days_margin: "Nombre de jours avant l'émission d'un WARNING",
         crg_error_days_margin: "Nombre de jours avant l'émission d'une ERREUR",
         crg_org_regex: "Motif REGEX",

         cer_cn: "Nom du Certificat (Common Name)",
         cer_active: "Actif",
         cer_masked: "Non listé dans les rapports",
         cer_comments: "Commentaires",
         cer_registar: "Rattaché au Registre",
         cer_customer: "Rattaché au Client",
         cer_create_title: "Déclaration d'un Certificat",
         cer_update_title: "Mise à jour du Certificat",
         cer_delete_title: "Suppression du Certificat",

         ced_active: "Actif",
         ced_check_uri: "URL de check du Certificat",
         ced_check_server_or_ip: "Nom DNS ou IP du serveur",
         ced_starttls: "Mode STARTTLS",
         ced_auto_renew: "Auto-renouvellement",
         ced_history: "Historique sur les derniers jours",
         ced_disarm_warning: "Désactivation des alarmes",
         ced_cer_active: "Cert. actif",
         ced_cer_masked: "Cert. masqué",
         ced_cer_visible: "Cert. visible",
         ced_ced_active: "Dépl. actif",
         ced_create_title: "Déclaration d'un Déploiement de Certificat",
         ced_update_title: "Mise à jour du Déploiement de Certificat",
         ced_delete_title: "Suppression du Déploiement de Certificat",
         
         platform: "Plateforme",
         plf_code: "Code Plateforme",
         plf_name: "Nom de la Plateforme",
         plf_ws_url_base: "URL de base",
         plf_domain_radix: "Radical LDAP du domaine",
         service: "Service",

         ldc_create_title: "Création d'un Connecteur LDAP",
         ldc_update_title: "Mise à jour d'un Connecteur LDAP",
         ldc_delete_title: "Suppression d'un Connecteur LDAP",
         ldc_create_title_auth: "Création d'un Lien d'Identité",
         ldc_update_title_auth: "Mise à jour d'un Lien d'Identité",
         ldc_delete_title_auth: "Suppression d'un Lien d'Identité",

         xxx_dyn_connector_name: "Nom du présent connecteur LDAP",
         _xxx_ad_org_unit: "OU relative*",
         _xxx_dyn_ldap_uri: "URI LDAP du Serveur *",
         _xxx_dyn_ldap_basedn: "BaseDN du Serveur *",
         _xxx_dyn_ldap_bind_login: "Compte d'accès LDAP (BIND) *",
         _xxx_dyn_ldap_bind_password: "Mot de passe d'accès *",
         _xxx_maxdbsize: "Taille max des DB",
         _xxx_databases: "Bases de Données Exchange",
         _xxx_servers: "Serveurs Exchange",
        
         lde_create_title: "Création d'une Entité LDAP",
         lde_update_title: "Mise à jour de l'Entité",
         lde_delete_title: "Suppression de l'entité LDAP",
         lde_select_ldt_create: "Vous pouvez créer ici une entité du type suivant",
         lde_path_on_create: "La future entité LDAP sera stockée dans ce chemin",
         lde_root: "<Racine>",
         lde_cn: "Nom Commun (CN)",
         lde_givenname: "Prénom",
         lde_sn: "Nom",
         lde_displayname: "Nom Complet",
         lde_mail: "Mél",
         lde_mail_and_upn: "Mél (et Identifiant)",
         lde_groups: "Groupes",
         lde_distinguishedname: "Identifiant Complet (DistinguishedName)",
         lde_userprincipalname: "Identifiant principal (UPN)",
         lde_mail_and_userprincipalname: "Mél et Identifiant",
         lde_code: "Identifiant en format FQDN",
         lde_useraccountcontrols: "Options de Compte sélectionnées",

         lde_ACCOUNTDISABLE: "Compte désactivé",
         lde_PASSWD_CANT_CHANGE: "L'utilisateur ne peut pas changer le mot de passe",
         lde_DONT_EXPIRE_PASSWORD: "Le mot de passe n'expire jamais",

         shc_compactcode: "Code Compacté",
         shc_create_title: "Création d'un Raccourci",
         shc_update_title: "Mise à jour d'un Raccourci",
         shc_delete_title: "Suppression d'un Raccourci",

         vlan: "VLAN",
         vla_code: "Code de VLAN",
         vla_name: "Nom de VLAN",
         vla_vmware_name: "Nom de VLAN sous ESXi",
         vla_id: "ID VLAN",

         cus_create_title: "Création d'un Client",
         cus_update_title: "Mise à jour du Client",
         cus_delete_title: "Suppression du Client",
         cus_select_title: "Consultation du Client",
         cus_create_item: "Ajouter un Client",
         cus_name: "Raison sociale",
         cus_name_reseller: "Revendeur associé",
         cus_siret: "Siret",
         cus_vatnumber: "Numéro de TVA intracommunautaire",
         cus_active: "Client Actif",
         cus_blocked: "Client bloqué",
         cus_code: "Code Interne",
         cus_quadratuscode: "Code Quadratus (Comptabilité/Facturation)",
         cus_bm_id: "ID Client BM (Zoho)",
         cus_bm_billing_id: "ID Contact Facturation BM (Zoho)",
         cus_bm_shipping_id: "ID Contact Livraison BM (Zoho)",
         cus_bm_id_warning: "Ce Client n'est pas relié au BM (Prestashop). Avant de travailler sur ses Contacts, enregistrez-le SVP, fermez et re-ouvrez la fenêtre.",
         cus_bm_ddoemail_id: "Présence de zoho@ddo.net dans ZOHO",
         cus_main_domain: "Domaine DNS Principal",
         cus_glpi_id: "ID Entité GLPI",
         cus_invoice_default_reseller: "Facturation au Revendeur",
         cus_can_change_dkim_selector: "Peut changer le sélecteur DKIM",

         cut_name: "Type de Client",

         plf_create_item: "Ajouter une Plateforme",

         cusplf_create_title: "Attacher une Plateforme",
         cusplf_update_title: "Mise à jour des informations de la Plateforme",
         cusplf_delete_title: "Suppression du rattachement de la Plateforme",
         cusplf_select_title: "Affichage des informations de la Plateforme",

         cusser_create_title: "Attacher un Service",
         cusser_update_title: "Mise à jour des informations du Service",
         cusser_delete_title: "Suppression du rattachement du Service",

         messages_sent_monthly: "messages envoyés ce mois",
         messages_sent_last30: "messages envoyés ces 30 derniers jours",
         megabytes_sent_monthly: "méga-octets envoyés ce mois",
         megabytes_sent_last30: "méga-octets envoyés ces 30 derniers jours",

         xxx_maxusers: "Nombre maximum de Comptes",
         xxx_max_emails_per_month: "Nombre maximum de mails envoyés par mois",
         xxx_max_gigabytes_per_month: "Nombre maximum de Gigaoctets envoyés par mois",
         sasl_usernames: "Comptes",
         sasl_username: "Compte",
         sasl_usernames_bareos: "Noms BAREOS des PC/Serveurs",
         sasl_username_bareos: "Noms BAREOS des PC/Serveurs",
         emails_per_month: "Emails par mois",

         xxx_sms_used: "SMS envoyés",

         xxx_inform_to_emails: "Email(s) Client",
         xxx_inform_cc_emails: "Email(s) Manager",
         xxx_mailprofile_to: "Template de Mail pour le Client",
         xxx_mailprofile_cc: "Template de Mail pour le Manager",
         xxx_suspend_on_threshold: "Suspendre si franchissement de limite",
         xxx_inform_warn_level: "Niveau de déclenchement des Mails",
         xxx_can_change_dkim_selector: "Peut changer le sélecteur DKIM",

         xxx_bareosclientname: "Nom du 'client' BAREOS",

         usr_create_title: "Création d'un Compte",
         usr_update_title: "Mes informations",
         usr_delete_title: "Suppression du Compte",
         usr_update_password: "Changer mon mot de passe",
         usr_login: "Identifiant (Login)",
         usr_firstname: "Prénom",
         usr_lastname: "Nom",
         usr_email: "Email",
         usr_displayname: "Nom d'affichage",
         usr_phone_mobile: "Téléphone mobile",
         usr_upn_differs_from_email: "Changer l'email et aligner le Login avec cet email",

         equ_name: "Nom de l'Equipement",
         eqt_name: "Type",
         equ_positions: "Positions du bas vers le haut",
         equ_on_front: "En face avant",
         equ_create_title: "Création d'un Equipement",
         equ_update_title: "Mise à jour de l'Equipement",
         equ_delete_title: "Suppression de l'Equipement",

         smtppro_mails_month: "Messages envoyés ce mois",
         smtppro_mails_month_cumulative: "Messages en cumulé envoyés ce mois",
         smtppro_mails_last12months: "Messages envoyés ces 12 derniers mois",
         smtppro_bytes_month: "Volume ce mois",
         smtppro_bytes_month_cumulative: "Volume en cumulé ce mois",
         smtppro_bytes_last12months: "Volume ces 12 derniers mois",
         smtppro_mails_last30: "Messages sur les 30 derniers jours",
         smtppro_bytes_last30: "Volume sur les 30 derniers jours",
         smtppro_mails_month_short: "envoyés ce mois",
         smtppro_mails_month_cumulative_short: "en cumulé, envoyés ce mois",
         smtppro_mails_last12months_short: "ces 12 derniers mois",
         smtppro_bytes_month_short: "ce mois",
         smtppro_bytes_month_cumulative_short: "en cumulé, délivrés ce mois",
         smtppro_bytes_last12months_short: "ces 12 derniers mois",
         smtppro_mails_last30_short: "sur les 30 derniers jours",
         smtppro_bytes_last30_short: "sur les 30 derniers jours",
         smtppro_mails_sent: "Délivrés",
         smtppro_mails_bounced: "Rejetés",
         smtppro_mails_expired: "Expirés",
         smtppro_mails_deferred: "Retardés",

         smtppro_search_and_export: "Rechercher, avec les critères ci-dessus, et exporter les résultats en fichier CSV",
         smtppro_direct_monthly_export: "Exporter directement avec les critères ci-dessus, pour un mois donné, en fichier CSV",

         smspro_sms_month: "SMS envoyés ce mois",
         smspro_sms_month_cumulative: "SMS en cumulé envoyés ce mois",
         smspro_sms_last12months: "SMS envoyés ces 12 derniers mois",
         smspro_bytes_month: "Volume ce mois",
         smspro_bytes_month_cumulative: "Volume en cumulé ce mois",
         smspro_bytes_last12months: "Volume ces 12 derniers mois",
         smspro_sms_last30: "SMS sur les 30 derniers jours",
         smspro_bytes_last30: "Volume sur les 30 derniers jours",
         smspro_sms_month_short: "envoyés ce mois",
         smspro_sms_month_cumulative_short: "en cumulé, envoyés ce mois",
         smspro_sms_last12months_short: "ces 12 derniers mois",
         smspro_bytes_month_short: "ce mois",
         smspro_bytes_month_cumulative_short: "en cumulé, délivrés ce mois",
         smspro_bytes_last12months_short: "ces 12 derniers mois",
         smspro_sms_last30_short: "sur les 30 derniers jours",
         smspro_bytes_last30_short: "sur les 30 derniers jours",
         smspro_sms_sent: "Délivrés",
         smspro_sms_bounced: "Rejetés",
         smspro_sms_expired: "Expirés",
         smspro_sms_deferred: "Retardés",

         backupbareos_jobs_month: "Travaux de sauvegarde ce mois",
         backupbareos_jobs_month_cumulative: "Travaux en cumulé ce mois",
         backupbareos_jobs_last12months: "Travaux ces 12 derniers mois",
         backupbareos_files_month: "Fichiers sauvegardés ce mois",
         backupbareos_files_month_cumulative: "Fichiers en cumulé ce mois",
         backupbareos_files_last12months: "Travaux ces 12 derniers mois",
         backupbareos_bytes_month: "Volume ce mois",
         backupbareos_bytes_month_cumulative: "Volume en cumulé ce mois",
         backupbareos_bytes_last12months: "Volume ces 12 derniers mois",

         backupbareos_jobs_day_short: "ce jour",
         backupbareos_jobs_month_short: "ce mois",
         backupbareos_jobs_month_cumulative_short: "En cumulé ce mois",
         backupbareos_jobs_last12months_short: "sur les 12 derniers mois",
         backupbareos_jobs_last30_short: "sur les 30 derniers jours",
         backupbareos_files_day_short: "ce jour",
         backupbareos_files_month_short: "ce mois",
         backupbareos_files_month_cumulative_short: "En cumulé ce mois",
         backupbareos_files_last12months_short: "sur les 12 derniers mois",
         backupbareos_files_last30_short: "sur les 30 derniers jours",
         backupbareos_bytes_day_short: "ce jour",
         backupbareos_bytes_month_short: "ce mois",
         backupbareos_bytes_month_cumulative_short: "En cumulé ce mois",
         backupbareos_bytes_last12months_short: "sur les 12 derniers mois",
         backupbareos_bytes_last30_short: "sur les 30 derniers jours",

         backupbareos_jobs_done: "Traité",
         backupbareos_jobs_cancelled: "Annulé",
         backupbareos_jobs_failed: "Echoué",

         search_xxx_sasl_usernames: "Nom du compte",
         search_radix_from: "<Premiers caractères de l'email de l'Expéditeur>",

         search_radix_from_recipient: "<Premiers chiffres du numéro de téléphone du destinataire>",
         search_radix_from_sentfromip: "<First chiffres of Sent from IP>",
         search_radix_from_sendingname: "<Premiers caractères du nom d'envoi>",

         search_radix_to: "<Premiers caractères de l'email du Destinataire>",
         search_domain_from: "<Premiers caractères de l'email du domaine de messagerie de l'Expéditeur>",
         search_domain_to: "<Premiers caractères de l'email du domaine de messagerie du Destinataire>",
         choose_dropdown_graph: "Choisissez un Graphe",
         choose_dropdown_account: "Choisissez un Compte",
         search_start_with: "Commence par :",
         search_sent_from_ip: "Entrer votre adresse IP :",
         search_results_hasbeendelivered: "A ÉTÉ DÉLIVRÉ",
         search_results_hasbeenrejected: "A ÉTÉ REJETÉ",
         search_results_hasexpired: "A EXPIRÉ",
         search_results_hasbeendeferred: "A ÉTÉ RETARDÉ",
         search_results_comments: "L'Email sortant, de <strong>'%s'</strong> à <strong>'%s'</strong> <mark>%s</mark>",
         search_results_comments_clean: "L'Email sortant, de '%s' à '%s' %s",

         search_results_hasbeendoned: "A ÉTÉ TRAIÉ ",
         search_results_hasbeencancelled: "A ÉTÉ ANNULÉ",
         search_results_hasbeenfailed: "A ÉTÉ ÉCHOUÉ",

         search_log_function: "Fonction",
         search_log_action: "Action",
         search_log_cus_activated: "La recherche est faite pour le Client %s",
         search_log_cus_deactivated: "La recherche est faite sur tous les Clients",

         ser_certificates_explanations_create: "En cliquant sur le bouton 'Créer', vous allez attacher au Client le Système de Surveillance des Certificats. Ce système surveille tous les certificas déclarés, leurs déploiements sur des serveurs, et leur date d'échéance",
         ser_certificates_explanations_update: "Rien à changer...",
         ser_certificates_explanations_delete: "En cliquant sur le bouton 'Supprimer', vous allez détacher le Client du Système de Surveillance des Certificats",

         ctc_name_general: "Contact principal",
         ctc_name_invoicing: "Contact / Facturation",
         ctc_name_shipping: "Contact / Livraison",
         ctc_create_title: "Création d'un Contact",
         ctc_update_title: "Mise à jour du Contact",
         ctc_delete_title: "Suppression du Contact",
         ctc_organizationname: "Fonction",
         ctc_firstname: "Prénom",
         ctc_lastname: "Nom",
         ctc_addr_line1: "Ligne 1",
         ctc_addr_line2: "Ligne 2",
         ctc_addr_zipcode: "Code Postal",
         ctc_addr_city: "Ville",
         ctc_addr_country: "Pays",
         ctc_affectations: "Affectations",
         ctc_create_contact: "Créer des Contacts",
         ctc_is_invoicing: "Utilisable pour facturation",
         ctc_is_shipping: "Utilisable pour livraison",
         ctc_phone_fixed_phone: "Numéro de téléphone fixe",
         ctc_phone_cell_phone: "Numéro de téléphome mobile",
         ctc_vatnumber: "Numéro de TVA intracommunautaire",
         ctc_bm_id: "ID Contact BM (ZOHO)",
         ctc_bm_address_billing_id: "ID Adresse Facturation BM (ZOHO)",
         ctc_bm_address_shipping_id: "ID Adresse Livraison BM (ZOHO)",

         ctc_billing_same_as_general: "Même adresse que 'Générale'",
         ctc_shipping_same_as_billing: "Même adresse que 'Facturation'",
         ctc_shipping_same_as_general: "Même adresse que 'Générale'",

         ctt_name: "Titre",

         prc_active: "Actif",
         prc_name: "Nom de la Catégorie",
         prc_internalcode: "Code interne",
         prc_visible_on_front: "Visible sur Front-Office",
         prc_for_logged_customer: "Seulement pour client connecté",
         prc_create_title: "Création d'une Catégorie",
         prc_update_title: "Mise à jour de la Catégorie",
         prc_delete_title: "Suppression de la Catégorie",

         pro_active: "Actif",
         pro_is_periodic: "Récurrent",
         pro_visible_on_front: "Visible sur Front-Office",
         pro_default_plan: "Plan par défaut",
         pro_price: "Prix (HT)",
         pro_setup_price: "Prix de mise en place (HT)",
         pro_yearly_price: "Prix (HT) (annuel)",
         pro_yearly_setup_price: "Prix de mise en place (HT) (annuel)",
         pro_image_link: "Image",
         pro_name: "Nom Produit",
         pro_flags: "Drapeaux",
         pro_reseller_nrr_discount: "Remise revendeur NRR",
         pro_reseller_mrr_discount: "Remise revendeur MRR",
         pro_create_title: "Création d'un Produit",
         pro_update_title: "Mise à jour du Produit",
         pro_delete_title: "Suppression du Produit",
         producttype: "Type ZOHO",
         productcategory: "Catégorie parente",

         xxx_method: "Méthode de décomptage",
         method_recurrent: "Méthode par abonnement (récurrent)",
         method_quota: "Méthode par quota (achat)",

         inv_export_to_accounting: "Marquer chaque ligne comme 'exportée' en compta",
         inv_export_include_accounting: "Même si la ligne a été marquée comme 'exportée', l'inclure en sortie",
         explanation_sync_from_zoho_invoices: "Avant de lancer la conversion, il peut être nécessaire de re-synchroniser les factures/avoirs de ZOHO",
         explanation_select_and_pay_invoices: "Vous pouvez sélectionner une ou plusieurs factures non payées, et cliquer sur le bouton 'Payer par Carte Bancaire'",
         selected_amount: "Montant des factures sélectionnées",
         due_amount: "Montant dû",

         dkr_create_title: "Création d'un DKIM sur Nom de Domaine Internet",
         dkr_declare_title: "Déclaration d'un DKIM sur Nom de Domaine Internet",
         dkr_update_title: "Mise à jour d'un DKIM sur Nom de Domaine Internet",
         dkr_delete_title: "Suppression d'un DKIM sur Nom de Domaine Internet",
         dkr_domainname: "Nom de domaine Internet",
         dkr_selector: "Sélecteur DKIM",

         dkr_declare_item: "Déclarer un DKIM sur un de vos Noms de Domaine Internet",
         dkim_last_check: "Dernière vérification le",

         sla_computed: "SLA Calculé",
         sla_active: "SLA Actif",
         sla_positive: "SLA Positif",

         level_sla: "SLA",
         sla_currentmonth: "ce Mois",
         sla_last12months: "sur les 12 derniers Mois",

     },

      hints: {
         _code: "Code unique",
         _name: "Nom lisible",
         _desc: "Description complète",

         signin_email: "correspond à votre email",
         signin_password: "correspond à votre mot de passe",
         change_password1: "Votre nouveau mot de passe doit avoir une longueur minimale de 8 caractères, et satisfaire 3 des 4 critères suivants :<ul><li>Au moins une minuscule,</li><li>Au moins une MAJUSCULE,</li><li>Au moins un chiffre,</li><li>Au moins un caractère spécial parmi la liste suivante : ? ! & §,</li></ul>",
         change_password2: "",

         net_cidr: "de la forme x.x.x.x/y",
         net_deployable: "peut générer une liste d'adresses IP",
         network_subnet_regex_mask: "Une chaine 'regex'pour générer une partie, mais pas tous, des sous-réseaux",

         dtc_address: "Adresse postale",

         dtr_position: "Rang de la Rangée dans le Datacenter",

         rck_position: "Rang de la Baie dans la Rangée",
         rck_size_u: "Fréquemment 42 U",
         rck_width_mm: "Fréquemment 600 (mm)",
         rck_depth_mm: "Fréquemment 1000 (mm), 800, 600, ...",

         cer_comments: "Commentaires sur ce Certificat",

         ced_check_uri: "Cette URL doit commencer par le protocole, à savoir https:// ou smtps://",
         ced_check_server_or_ip: "Au cas où le check ne peut pas se décrire par la première possibilité, l'alternative est de donner une IP et éventuellement un Port",
         ced_starttls: "Le Mode STARTTLS s'applique aux checks smtps://",
         ced_auto_renew: "Auto-renouvellement",
         ced_disarm_warning: "La désactivation des alarmes permet de ne pas enregistrer (à vérifier?) ce check",

         xxx_connector_name: "Nom du présent connecteur LDAP, dans le cas des Plateformes dynamiques, pour les distinguer",
         xxx_ad_org_unit: "Organization Unit (en relatif par rapport à la base du serveur)",
         xxx_dyn_ldap_uri: "URI pour accéder au serveur LDAP, en format ldap://... or ldaps://...",
         xxx_dyn_ldap_basedn: "Base DN du serveur, en format OU=...,DC=...,DC=...,DC=...",
         xxx_dyn_ldap_bind_login: "Code Utilisateur pour se connecter au serveur. Pour un serveur Active Directory, dans le format <DOMAINE>\<CodeUtilisateur> ou <UserPrincipalName> (UPN)",
         xxx_dyn_ldap_bind_password: "Mot de passe de l'Utilisateur/Administrateur",
         lde_cn: "Nom Commun (CN)",
         lde_givenname: "Prénom",
         lde_sn: "Nom",
         lde_displayname: "Nom Complet",
         lde_mail_and_upn: "Le Mél servira aussi d'Identifiant (UPN)",
         lde_mail: "Le Mél associé au Compte",

         xxx_inform_to_emails: "Liste d'Emails séparés par des ','. Chaque Email sera informé dès qu'un seuil est franchi",
         xxx_inform_cc_emails: "Liste d'Emails séparés par des ','. Chaque Email sera informé dès qu'un seuil est franchi",
         xxx_suspend_on_threshold: "Le compte est suspendu si un seuil est franchi. Le Compte est réactivé au premier jour du prochain mois",
         xxx_inform_warn_level: "Les Emails ne sont envoyés que si le niveau d'alerte est équal ou supérieur à ce niveau",

         crg_name: "Nom du Registre",
         crg_uri: "URL du site Web",
         crg_warn_days_margin: "Nombre de jours avant l'émission d'un WARNING",
         crg_error_days_margin: "Nombre de jours avant l'émission d'une ERREUR",
         crg_org_regex: "Motif REGEX, généralement une chaîne contenant le/les caractères |, for séparer chaque possibilité",

         vla_id: "VLAN ID, dans l'intervalle 0..4095",
         vla_vmware_name: "Nom de VLAN, déclaré dans tous les ESXi, gérés ou non sous vCenter",

         usr_login: "Cet identifiant doit être UNIQUE",
         usr_displayname: "Généralement : <NOM>, <Prénom>, ou <Prénom> <NOM>",
         usr_email: "Votre email sur lequel des notifications pourront vous être envoyées",
         usr_phone_mobile: "ce numéro de téléphone peut servir de contrôle de connexion. Un code de sécurité pourrait vous être envoyé dessus en SMS.",
         usr_upn_differs_from_email: "Le 'Login' et l'Email sont souvent les mêmes. Mais ils peuvent être dissocés. Si vous sélectionnez cette option, changer votre Email impliquera le changement du Login par la même valeur. Vous serez déconnecté, et vous devrez vous reconnecter juste après la modification.",

         search_xxx_sasl_usernames: "Nom du compte SMTP-PRO",
         search_radix_from: "Caractères du début de la première partie de l'email de l'Expéditeur, en minuscules. Exemple : 'jean' pour 'jean.dupont@exemple.com'",
         search_radix_to: "Caractères du début de la première partie de l'email du Destinataire, en minuscules. Exemple : 'jean' pour 'jean.dupont@exemple.com'",
         search_domain_from: "Caractères du début de la seconde partie de l'email de l'Expéditeur (partie après @, aussi appelée le 'domaine'), en minuscules. Exemple : 'exempl' pour 'jean.dupont@exemple.com'",
         search_domain_to: "Caractères du début de la seconde partie de l'email du Destinataire (partie après @, aussi appelée le 'domaine'), en minuscules. Exemple : 'exempl' pour 'jean.dupont@exemple.com'",

         cus_name: "Raison Sociale/Nom du Client. Doit être identique ou le plus proche possible du nom officiel du Client",
         cus_code_create: "Code Alphanumérique (A-Z,0-9, et '-'). Ce code est automatiquement généré par le système, à partir de la Raison Sociale. Il peut être manuellement changé en cliquant sur l'icône d'édition. Les codes générés sont vérifiés pour ne pas exister, les codes édités manuellement ne sont pas vérifiés",
         cus_code_update: "Code Alphanumérique (A-Z,0-9, et '-'). Ce code ne peut plus être changé.",
         cus_siret: "Numéro de SIRET, ou à défaut, numéro de SIREN",
         cus_vatnumber: "Numéro de TVA intracommunautaire",
         cus_main_domain: "Domaine DNS Principal (sans le @)",

         pro_reseller_nrr_discount: "Remise revendeur pour le Non-Récurrent",
         pro_reseller_mrr_discount: "Remise revendeur pour le Récurrent Mensuel",

         xxx_bareosclientname: "Nom de  l'entité 'client' dans la configuration de BAREOS. Ce lien permettra le rapprochement avec les remontées des différents backups faits par ce client",

         dkr_domainname: "Vous devez avoir la gestion DNS de votre Nom de Domaine, pour pouvoir y créer un enregistrement TXT pour le DKIM. N'importe quel nom, dont vous avez la gestion, est autorisé : exemple.com, mon-domaine.fr, ...",
         dkr_selector: "Toute combinaison de caractères et de chiffres, compatibles avec les règles de nommage de DNS",
      },

      messages: {
         password_not_complex: "Le mot de passe n'est pas assez complexe",
         _spf_full_settings_1: "<strong>SPF (Sender Policy Framework)</strong> est une méthode d'authentification d'envoi de mails décrite ici : <a href='https://en.wikipedia.org/wiki/Sender_Policy_Framework' target='_blank'><strong>Wikipedia</strong></a>",
         _spf_full_settings_2: "Pour appliquer SPF dans SMTP-PRO pour votre domaine Internet, vous avez juste à créer ou mettre à jour un enregistrement DNS, de type TXT, sur votre domaine Internet. Par exemple : mon-domaine.com, l'écriture la plus simple, pour permettre à SMTP-PRO d'être autorisé à envoyer vos mails, est :",
         _spf_full_settings_3: "<strong><pre>v=spf1 include:_spf.smtp-pro.com ~all</pre></strong>",
         _spf_full_settings_4: "Si vous avez déjà un enregistrement SPF dans vos DNS, ajoutez-lui simplement : <strong><pre>include:_spf.smtp-pro.com</pre></strong>",

         _dkim_full_settings_1: "<strong>DKIM (DomainKeys Identified Mail)</strong> est une méthode d'authentification d'envoi de mails décrite ici : <a href='https://en.wikipedia.org/wiki/DomainKeys_Identified_Mail' target='_blank'><strong>Wikipedia</strong></a>",
         _dkim_full_settings_2: "Pour appliquer le <strong>DKIM</strong> dans SMTP-PRO pour votre(vos) domaine(s) Internet, vous avez juste à créer un enregistrement DNS, de type <strong>TXT</strong>, pour chacun de vos domaines Internet. Vous avez la possibilité de créer ici des clés DKIM pour chacun de vos domaines, juqu'à 10 au maximum. Cette création est un processus à 3 étapes :",
         _dkim_full_settings_3: "<ul><li>Créez un enregistrement <strong>DKIM</strong> pour un domaine Internet dans notre système</li><li>Déclarez un enregistrement <strong>TXT</strong> dans votre console DNS pour ce domaine</li><li>Vérifiez et validez votre enregistrement DKIM</li></ul>",
         _dkim_full_settings_4: "Pour rappel : <strong>SMTP-PRO</strong> ne vous restreint pas sur l'utilisation de domaines Internet, lorsque vous envoyez des mails, mais vous devez déclarer un enregistrement DKIM pour chacun de vos domaines d'émission ('<strong>From: </strong>'), à concurrence de 10 maximum, pour améliorer votre déliverabilité",

         _dkim_record_explanation_1: "Merci de déclarer un enregistrement TXT pour votre domaine : <strong><pre>%s</pre></strong>, avec comme clé : <strong><pre>%s</pre></strong>, et ayant comme valeur :",
         _dkim_record_explanation_2: "<mark>Cette dernière valeur a été copiée dans votre Presse-Papier.</mark>",

         inv_tracking_message_already_flagged: 'Facture %s déjà exportée. Ligne sautée',
         inv_tracking_message_now_flagged: 'Facture %s maintenant marquée comme exportée',
         inv_tracking_message_row_included: 'Facture %s re-présentée en sortie',
         inv_tracking_message_not_found: 'Facture %s non trouvée',

      },

      tooltips: {
         edit: "Editer",
         delete: "Supprimer",
         open: "Ouvrir",
         close: "Fermer",
         details: "Détails",
         create: "Créer",
         attach: "Attacher",
         detach: "Détacher",
         copy: "Copier",
         clipboard: "Copier dans Presse-papiers",
         dns_validated: "Enregistrement DNS validé",
         dns_not_validated: "Enregistrement DNS NON validé",
      },

   }
}